export default "__VITE_ASSET__BTa_dbiL__"